export default {
  getMapStyle: state => {
    return state.map_style;
  },
  getMapLayers: state => {
    return state.layers;
  },
  getStyles: state => {
    return state.styles.map(item => {
      let isActive = false;
      if (item.url === state.map_style) {
        isActive = true;
      }
      return {
        ...item,
        isActive,
        image: `https://api.mapbox.com/styles/v1/${item.url.slice(
          16,
          item.url.length
        )}/static/-122.4241,37.78,14.25,0,60/600x600?access_token=pk.eyJ1IjoiaGF4emllIiwiYSI6ImNqZ2c2NWp3OTBxenAzM3FzeThydmZ0YncifQ.584ugILuKFfDPTxqyiO_0g`,
      };
    });
  },
  getLegend: state => {
    return state.legend;
  },
  getMapLegends: state => {
    return state.mapLegends;
  },
  getGeoData: state => {
    return state.geoData;
  },
  getZoom: state => {
    return state.zoomLevel;
  },
  getOpacity: state => {
    return state.opacity;
  },
  isTilted: state => {
    return state.isTilted;
  },
  getPopupData: state => {
    return state.popupData;
  },
  getGridFilter: state => {
    return state.gridFilter;
  },
  getMapFilters: state => {
    return state.mapFilters;
  },
  getPopups: state => {
    return state.popups;
  },
  getViewState: state => {
    return state.viewState;
  },
  getCities: state => {
    return state.cities;
  },
  getFetchingCities: state => {
    return state.fetching_cities;
  },
  getActiveCity: state => {
    return state.activeCity;
  },
  getOverlays: state => {
    return state.overlays;
  },
  getContextData: state => {
    return state.contextData;
  },
  getMeasureData: state => {
    return state.measureData;
  },
  showMeasureTool: state => {
    return state.showMeasureTool;
  },
  getActiveGrid: state => {
    return state.activeGrid;
  },
  getActiveLocation: state => {
    return state.activeLocation;
  },
};
